import { FormType } from '../../../form-types';

export const menHairLoss: FormType = {
  name: 'Men Hair Loss',
  olderVersions: ['menHairLoss_archived'],
  questions: [
    {
      key: 'menHairLoss_sexAssignedAtBirth',
      next: {
        condition: {
          'menHairLoss_sexAssignedAtBirth.menHairLoss_sexAssignedAtBirth_male':
            true
        },
        key: 'menHairLoss_affectedAreas',
        els: 'menHairLoss_ineligible'
      }
    },
    {
      key: 'menHairLoss_affectedAreas',
      next: {
        condition: {
          'menHairLoss_affectedAreas.menHairLoss_affectedAreas_other': true
        },
        key: 'menHairLoss_affectedAreas_other_more',
        els: 'menHairLoss_howLongHaveYouBeenExperiencingHairLoss'
      }
    },
    'menHairLoss_affectedAreas_other_more',
    'menHairLoss_howLongHaveYouBeenExperiencingHairLoss',
    'menHairLoss_howMuchHairHaveYouLost',
    {
      key: 'menHairLoss_hairLossCause',
      next: {
        condition: {
          'menHairLoss_hairLossCause.menHairLoss_hairLossCause_other': true
        },
        key: 'menHairLoss_hairLossCause_other_why',
        els: 'menHairLoss_scalpConditions'
      }
    },
    'menHairLoss_hairLossCause_other_why',
    'menHairLoss_scalpConditions',
    'menHairLoss_scalpIrritation',
    {
      key: 'menHairLoss_hairLossInDifferentPartsOfBody',
      next: {
        condition: {
          'menHairLoss_hairLossInDifferentPartsOfBody.menHairLoss_hairLossInDifferentPartsOfBody_yes':
            true
        },
        key: 'menHairLoss_hairLossInDifferentPartsOfBody_more',
        els: 'menHairLoss_hairLossTreatments'
      }
    },
    'menHairLoss_hairLossInDifferentPartsOfBody_more',
    {
      key: 'menHairLoss_hairLossTreatments',
      next: {
        condition: {
          'menHairLoss_hairLossTreatments.menHairLoss_hairLossTreatments_yes':
            true
        },
        key: 'menHairLoss_hairLossTreatments_yes_more',
        els: 'menHairLoss_medicalConditions'
      }
    },
    'menHairLoss_hairLossTreatments_yes_more',
    'menHairLoss_medicalConditions',
    {
      key: 'menHairLoss_moodDisorders',
      next: {
        condition: {
          'menHairLoss_moodDisorders.menHairLoss_moodDisorders_yes': true
        },
        key: 'menHairLoss_moodDisorders_yes_more',
        els: 'menHairLoss_planOnHavingChildrenSoon'
      }
    },
    'menHairLoss_moodDisorders_yes_more',
    'menHairLoss_planOnHavingChildrenSoon',
    'menHairLoss_otherInformationOrQuestions',
    {
      key: 'menHairLoss_consent',
      next: {
        condition: {
          'menHairLoss_consent.menHairLoss_consent_consent': true
        },
        key: 'menHairLoss_complete',
        els: 'menHairLoss_ineligible'
      }
    },
    'menHairLoss_complete',
    'menHairLoss_ineligible'
  ]
};
export const menHairLoss_archived: FormType = {
  name: 'Men Hair Loss',
  questions: [
    {
      key: 'menHairLoss_archived_sexAssignedAtBirth',
      next: {
        condition: {
          'menHairLoss_archived_sexAssignedAtBirth.menHairLoss_archived_sexAssignedAtBirth_male':
            true
        },
        key: 'menHairLoss_archived_height',
        els: 'menHairLoss_archived_ineligible'
      }
    },
    'menHairLoss_archived_ineligible',
    'menHairLoss_archived_height',
    'menHairLoss_archived_weight',
    'menHairLoss_archived_currentMedicalConditions',
    'menHairLoss_archived_currentMedications',
    'menHairLoss_archived_knownAllergies',
    'menHairLoss_archived_affectedAreas',
    'menHairLoss_archived_howLongHaveYouBeenExperiencingHairLoss',
    'menHairLoss_archived_howMuchHairHaveYouLost',
    'menHairLoss_archived_hairLossCause',
    'menHairLoss_archived_scalpConditions',
    'menHairLoss_archived_scalpIrritation',
    'menHairLoss_archived_hairLossInDifferentPartsOfBody',
    'menHairLoss_archived_hairLossTreatments',
    'menHairLoss_archived_medicalConditions',
    'menHairLoss_archived_moodDisorders',
    'menHairLoss_archived_planOnHavingChildrenSoon',
    'menHairLoss_archived_otherInformationOrQuestions',
    'menHairLoss_archived_consent'
  ]
};
